import { useImpersonation } from '@/contexts/ImpersonationContext';
import WidgetDashboard from '@/components/dashboard/WidgetDashboard';

function getGreeting(name: string): string {
  const hour = new Date().getHours();
  if (hour < 6) return `God natt, ${name}`;
  if (hour < 10) return `God morgen, ${name}`;
  if (hour < 12) return `God formiddag, ${name}`;
  if (hour < 17) return `God ettermiddag, ${name}`;
  return `God kveld, ${name}`;
}

export default function DashboardPage() {
  const { activeUser } = useImpersonation();

  const effectiveRole = activeUser?.role ?? 'employee';
  const firstName = activeUser?.full_name?.split(' ')[0] ?? '';

  // Admin sees "Måltall", others get a greeting
  const greeting = effectiveRole === 'admin'
    ? 'Måltall'
    : getGreeting(firstName);

  return <WidgetDashboard role={effectiveRole} greeting={greeting} />;
}
